import { apiHelper } from './../api_helper';
export const SF_MUCTHUPHI_SELECT_ALL_API = "finance-helper/sf_mucthuphi_select_all";
export const SF_MUCTHUPHI_SELECT_BY_NAM_NHAP_HOC_API = "finance-helper/sf_mucthuphi_select_nam_nhap_hoc";
export const SF_MUCTHUPHI_SAVECHANGES_API = "finance-helper/sf_mucthuphi_savechanges";
export const SF_MUCTHUPHI_ADDKHOANNOP_API = "finance-helper/sf_mucthuphi_add-khoan-nop";
export const SF_MUCTHUPHI_REMOVEKHOANNOP_API = "finance-helper/sf_mucthuphi_remove-khoan-nop";
export const SF_MUCTHUPHI_CREATE_SALESET_API = "finance-helper/sf_mucthuphi_create-saleset";
export const SF_KHOANNOP_SELECT_ALL_API = "finance-helper/sf_khoannop_select_all";
export const SF_KHOANNOP_GROUP_SELECT_ALL_API = "finance-helper/sf_khoannop_group_select_all";
export const SF_MUCPHAITHU_CHITIET_SELECTALL_KHOANNOP_API = "finance-helper/sf_mucphaithu_chitiet_select_all_khoannop";
export const SF_BOM_HINHTHUCNOPBOM_SELECT_ALL = "finance-helper/sf_hinhthucnopbom_select_all"
export const SF_TINHBAOPHI_INSERT_API = "finance-helper/sf_tinhbaophi_insert";
export const SF_TINHBAOPHI_SELECT_API = "finance-helper/sf_tinhbaophi_selectbyhocsinh";
export const SF_TINHBAOPHI_SELECTBYID_API = "finance-helper/sf_tinhbaophi_selectbyid";
export const SF_TINHBAOPHI_DELETE_API = "finance-helper/sf_tinhbaophi_delete";
export const SF_TINHBAOPHI_REMOVE_KHOANNOP_API = "finance-helper/sf_tinhbaophi_remove_khoannop";
export const SF_TINHBAOPHI_SENDMAIL_API = "finance-helper/sf_tinhbaophi_send_email";


export const financeHelperApi = {
    sf_mucphaithu_select: (request) => {
        return apiHelper.post(`${SF_MUCTHUPHI_SELECT_ALL_API}`, request)
    },
    sf_mucphaithu_select_by_nam_nhap_hoc: (request) => {
        return apiHelper.post(`${SF_MUCTHUPHI_SELECT_BY_NAM_NHAP_HOC_API}`, request)
    },
    sf_mucphaithu_savechanges: (data) => {
        return apiHelper.post(`${SF_MUCTHUPHI_SAVECHANGES_API}`, data)
    },
    sf_mucphaithu_addKhoanNop: (data) => {
        return apiHelper.post(`${SF_MUCTHUPHI_ADDKHOANNOP_API}`, data)
    },
    sf_mucphaithu_removeKhoanNop: (data) => {
        return apiHelper.post(`${SF_MUCTHUPHI_REMOVEKHOANNOP_API}`, data)
    },
    sf_mucphaithu_createSaleSet: (data) => {
        return apiHelper.post(`${SF_MUCTHUPHI_CREATE_SALESET_API}`, data)
    },
    sf_khoannop_select_all: () => {
        return apiHelper.post(`${SF_KHOANNOP_SELECT_ALL_API}`)
    },
    sf_khoannop_group_select_all: () => {
        return apiHelper.post(`${SF_KHOANNOP_GROUP_SELECT_ALL_API}`)
    },
    sf_mucphaithu_chitiet_select_all_khoannop:(request) => {
        return apiHelper.post(`${SF_MUCPHAITHU_CHITIET_SELECTALL_KHOANNOP_API}`, request)
    },
    sf_hinhthucnopbom_select_all: () => apiHelper.post(SF_BOM_HINHTHUCNOPBOM_SELECT_ALL),
    sf_tinhbaophi_insert: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_INSERT_API}`, data)
    },
    sf_tinhbaophi_selectbyhocsinh: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_SELECT_API}`, data)
    },
    sf_tinhbaophi_selectbyid: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_SELECTBYID_API}`, data)
    },
    sf_tinhbaophi_delete: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_DELETE_API}`, data)
    },
    sf_tinhbaophi_remove_khoannop: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_REMOVE_KHOANNOP_API}`, data)
    },
    sf_tinhbaophi_send_baophi: (data) => {
        return apiHelper.post(`${SF_TINHBAOPHI_SENDMAIL_API}`, data)
    },
}